import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

waitForEnv().then(() => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    // <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
    // </React.StrictMode>
  );
});

async function waitForEnv(maxRetries = 4, delay = 200) {
  let attempts = 0;

  while (!window.zino_env && attempts < maxRetries) {
    await new Promise((resolve) => setTimeout(resolve, delay));
    attempts++;
  }

  if (!window.zino_env) {
    throw new Error("Failed to load environment config after 2 attempts");
  }
}
